import { PlanState, PlanTypes } from './plans.types';

const initialState = { status: 'idle', data: {}, error: '' } as PlanState;

// eslint-disable-next-line @typescript-eslint/default-param-last
const plansReducer = (state = initialState, action: PlanTypes): typeof initialState => {
  switch (action.type) {
    case 'GET_PLANS_REQUEST': {
      return {
        ...state,
        status: state.status !== 'resolved' ? 'pending' : state.status
      };
    }
    case 'GET_PLANS_SUCCESS': {
      return {
        ...state,
        data: action.payload,
        status: 'resolved'
      };
    }
    case 'GET_PLANS_FAILURE': {
      return {
        ...state,
        status: 'rejected',
        error: action.payload
      };
    }

    default:
      return state;
  }
};

export default plansReducer;
